import React from 'react';
import type { Menu, MenuChoice as MenuChoiceType, RSVP } from '../../services/api';
import MenuChoice from './MenuChoice';

interface GuestRsvpProps {
  rsvp: RSVP;
  index: number;
  menu: Menu | undefined;
  handleRSVPChange: (index: number, field: keyof RSVP, value: boolean | string) => void;
  handleMenuChoiceChange: (index: number, field: keyof MenuChoiceType, value: string) => void;
  removeRSVP: (index: number) => void;
  t: (key: string) => string;
}

const GuestRsvp: React.FC<GuestRsvpProps> = ({
  rsvp,
  index,
  menu,
  handleRSVPChange,
  handleMenuChoiceChange,
  removeRSVP,
  t,
}) => {
  return (
    <div className="guest-element">
      <div className="guest-row-flex">
        <div className="guest-input-group">
          <label>{t('name')}</label>
          <input
            type="text"
            value={rsvp.name}
            onChange={e => handleRSVPChange(index, 'name', e.target.value)}
            placeholder={t('guestNamePlaceholder')}
          />
        </div>
        <div className="guest-input-group">
          <label>{t('attendingCeremony')}</label>
          <input
            type="checkbox"
            checked={rsvp.attending_ceremony}
            onChange={e => handleRSVPChange(index, 'attending_ceremony', e.target.checked)}
          />
        </div>
        <div className="guest-input-group">
          <label>{t('attendingReception')}</label>
          <input
            type="checkbox"
            checked={rsvp.attending_reception}
            onChange={e => handleRSVPChange(index, 'attending_reception', e.target.checked)}
          />
        </div>
        <div className="guest-input-group">
          <button
            type="button"
            className="remove-guest-button"
            onClick={() => removeRSVP(index)}
            data-tooltip={t('removeGuest')}
          >
            {t('removeGuest')}
          </button>
        </div>
      </div>
      {rsvp.menu_choice && (
        <MenuChoice
          menu_choice={rsvp.menu_choice}
          menu={menu}
          index={index}
          t={t}
          handleMenuChoiceChange={handleMenuChoiceChange}
        />
      )}
    </div>
  );
};

export default GuestRsvp;
